import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

export function AboutSustainability({ testimonials, sx, ...other }) {
  const { t } = useLocale();
  const renderHead = () => (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h2" sx={{ fontSize: '2rem !important' }}>
        {t('Sustainability_and_Corporate_Responsibility')}
      </Typography>
    </Box>
  );

  const renderText = () => (
    <>
      <Typography
        sx={{
          mt: 3,
          mx: 'auto',
          // maxWidth: 480,
          color: 'text.secondary',
          // mb: { xs: 5, md: 10 },
        }}
      >
        {t('Shahen_adopts_responsible_operational_practices')}
      </Typography>
    </>
  );

  return (
    <Box
      component="section"
      sx={[
        {
          py: { xs: 5, md: 7 },
          bgcolor: 'background.neutral',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container maxWidth={false} sx={{ maxWidth: 820, position: 'relative' }}>
        {renderHead()}
        {renderText()}
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------
